import {sprintf} from "@wordpress/i18n";

export const mapLineItems = (items) => {
    return items.map(item => {
        return {
            type: 'final',
            label: item.label,
            amount: item.amount
        }
    });
};

export const mapShippingOptions = (options, selectedOption) => {
    return options
        .map(option => ({
            label: option.label,
            detail: option.description || '',
            amount: option.amount,
            identifier: option.id,
        }))
        .sort((a, b) => {
            // Place selected option first
            if (a.identifier === selectedOption) return -1;
            if (b.identifier === selectedOption) return 1;
            // Sort remaining options by amount (lowest to highest)
            return parseFloat(a.amount) - parseFloat(b.amount);
        });
}

export const extractAddress = (data) => {
    if (!data) {
        return {};
    }
    const address = {};
    address.first_name = data.givenName || '';
    address.last_name = data.familyName || '';
    address.address_1 = data.addressLines?.[0] || '';
    address.address_2 = (data.addressLines?.slice(1).join(' ')) || '';
    address.city = data.locality || '';
    address.state = data.administrativeArea || '';
    address.postcode = data.postalCode || '';
    address.country = data.countryCode || '';

    if (data.phoneNumber) {
        address.phone = data.phoneNumber;
    }
    if (data.emailAddress) {
        address.email = data.emailAddress;
    }
    return address;
}

export const parsePaymentData = (payment) => {
    let data = {
        billingAddress: {},
        shippingAddress: {}
    };

    if (!payment) {
        return data;
    }

    if (payment.billingContact) {
        data.billingAddress = extractAddress(payment.billingContact);
    }

    if (payment.shippingContact) {
        const address = extractAddress(payment.shippingContact);

        // Copy phone and email from shipping to billing if billing doesn't have them
        if (address.phone && !data.billingAddress.phone) {
            data.billingAddress.phone = address.phone;
        }
        if (address.email && !data.billingAddress.email) {
            data.billingAddress.email = address.email;
        }

        data.shippingAddress = address;
    }

    return data;
}